import { initLogger as init, log as logger } from "@moment/logging";
import { env } from "@moment/state";

export type LogLevel = "debug" | "info" | "warn" | "error";

export const isSynthetics = () => {
	if (typeof window !== "undefined") {
		return window["_DATADOG_SYNTHETICS_BROWSER"] !== undefined;
	}

	return false;
};

export const initLogger = () => {
	let service = "browser";
	if (env.isDesktopApp) {
		service = "electron-renderer";
	} else if (env.isMobileApp) {
		service = "ios";
	}

	init(service);
};

export const log = (
	message: string,
	content?: Record<string, unknown>,
	level: LogLevel = "info"
): void => {
	logger(message, content, level);
};
